export default [
    {
        header: 'Settings',
        resource: 'Settings',
        action: 'permission',
     
    },
    {
      title: 'Languages',
      icon: 'FlagIcon',
      route: 'languages-read',  
      tagVariant: 'light-warning',
      resource: 'Languages',
      action: 'read',
     
     
    },
    {
      title: 'General',
      icon: 'SettingsIcon',
      route: 'settings-general',  
      tagVariant: 'light-warning',
      resource: 'Settings',
      action: 'general',
     
     
    },
    {
      title: 'Sites',
      icon: 'SettingsIcon',
      tagVariant: 'light-warning',
      resource: 'Sites',
      action: 'read',
      children: [
        {
          title: 'Sites',
          route: 'sites-read',  
          resource: 'Sites',
          action: 'read',
        },
        {
          title: 'Site Types',
          route: 'site-types-read',  
          resource: 'Sites',
          action: 'read',
        },
        {
          title: 'Destinations',
          route: 'destinations-read',  
          resource: 'Sites',
          action: 'read',
        }
      ]
    },
    {
      title: 'Component',
      icon: 'FileIcon',
     
      tagVariant: 'light-warning',
      resource: 'Component',
      action: 'read',
      children: [
        {
            title: 'Component',
            route: 'component-read',  
        
            resource: 'Component',
            action: 'read',
        },
        {
          title: 'Group',
          route: 'component-group-read',  
      
          resource: 'Component',
          action: 'read',
        },

      ]
     
     
    },
    // {
    //   title: 'Permission',
    //   icon: 'LockIcon',
    //   route: 'settings-groups',  
    //   tagVariant: 'light-warning',
    //   resource: 'Settings',
    //   action: 'permission',
     
     
    // },
]